import { defineStore } from 'pinia';

export default defineStore('account', () => {
  const phoneNumber = ref();
  const onboarded = ref(false);

  const hasPhoneNumber = computed((): boolean => {
    return !!phoneNumber.value;
  });

  const resetUser = (): void => {
    phoneNumber.value = null;
  };

  return {
    phoneNumber,
    onboarded,
    hasPhoneNumber,
    resetUser,
  };
});
